module.exports = __webpack_public_path__ + "img/dollarcoin.5bdbbe13.png";